import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule as MatMenuModule } from '@angular/material/menu';
import { MatListModule as MatListModule } from '@angular/material/list';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { MatCardModule as MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule as MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatRadioModule as MatRadioModule} from '@angular/material/radio';
import {MatSnackBarModule as MatSnackBarModule} from '@angular/material/snack-bar';
import {MatPaginatorModule as MatPaginatorModule,MatPaginatorIntl as MatPaginatorIntl} from '@angular/material/paginator';
import { NgModule } from '@angular/core';
import { CustomPaginator } from '../administration/CustomPaginatorConfiguration';
import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatProgressBarModule as MatProgressBarModule} from '@angular/material/progress-bar';
import { MatTableModule as MatTableModule } from '@angular/material/table';
@NgModule({
    exports:[
        MatPaginatorModule,
        MatToolbarModule,
        MatMenuModule,
        MatListModule,
        MatButtonModule,
        MatCardModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatDialogModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatRadioModule,
        MatSnackBarModule,
        MatRadioModule,
        MatStepperModule,
        MatButtonToggleModule,
        MatProgressBarModule,
        MatTableModule

    ],
    providers:[
        { provide: MatPaginatorIntl, useValue: CustomPaginator() }
    ]
})
export class MaterialModule{}